export function isCocCocBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('coc_coc_browser') || ua.includes('coccoc')) return true;

  const nav = navigator as Navigator & {
    userAgentData?: { brands?: Array<{ brand: string }> };
  };
  const brands = nav.userAgentData?.brands;
  if (brands?.some((b) => /coc\s*coc|coccoc/i.test(b.brand))) return true;

  return false;
}
